import Avatar from '../ui/Avatar';
import ProfileCard from '../ui/ProfileCard';
import CardState from '../ui/CardState';

/**
 * `tools` is null while loading, the string 'error' when the read failed, or
 * the list. A failed read is never shown as "No tools assigned.": that would
 * tell someone they have nothing when we simply don't know.
 */
export default function ToolAccessTab({ tools, isMemberView = false }) {
  const count = Array.isArray(tools) && tools.length ? ` · ${tools.length}` : '';
  return (
    <ProfileCard title={`Tool access${count}`} span>
      {tools === null && <CardState kind="loading" label="Loading tools" />}
      {tools === 'error' && <CardState kind="error" thing={isMemberView ? 'tools' : 'your tools'} />}
      {Array.isArray(tools) && tools.length === 0 && <CardState kind="empty">No tools assigned.</CardState>}
      {Array.isArray(tools) && tools.length > 0 && (
        <ul className="profile-tool-grid">
          {tools.map((t) => (
            <li key={t.id} className="profile-tool-card">
              <Avatar name={t.name} src={t.icon_url} size="tile" className="profile-tool-card__icon" />
              <span className="profile-tool-card__body">
                <span className="profile-tool-card__name" title={t.name}>{t.name}</span>
                {(t.category || t.type) && (
                  <span className="profile-tool-card__meta">{t.category || t.type}</span>
                )}
              </span>
            </li>
          ))}
        </ul>
      )}
    </ProfileCard>
  );
}
